import { COMPONENT_LAYOUT_LIST } from 'global/constants';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import { ViewProps } from '../link/link.constants';
import {
  PrintStimulusLink,
  PrintStimulusLinkNarrow,
} from '../print/print-stimulus';

const WebToolPrint = (props: ViewProps & CommonPrintProps) => {
  if (!props.stimulusResourceProperties?.link) return null;

  const printStimulusLinkProps = {
    primaryText: props.stimulusResourceProperties.resourceName,
    link: props.stimulusResourceProperties.link,
  };

  return (
    <>
      {props.properties.layout?.display === COMPONENT_LAYOUT_LIST ? (
        <PrintStimulusLinkNarrow
          {...printStimulusLinkProps}
          isPrintPreview={props.isPrintPreview}
        />
      ) : (
        <PrintStimulusLink
          {...printStimulusLinkProps}
          isPrintPreview={props.isPrintPreview}
        />
      )}
    </>
  );
};

export default WebToolPrint;
